<template>
  <div class="main-card mb-3 card">
    <div class="card-body">
      <h5 class="card-title">NetWork</h5>
      <table class="mb-0 table table-bordered">
        <tbody>
          <tr v-for="(net, index) in data" :key="index">
            <td width="13%">{{ net?.name }}</td>
            <td width="29%">
              In : <span>{{ net?.network_input }}</span>
            </td>
            <td width="14%">
              Real time: <span>{{ net?.network_input_speed_realtime }}</span>
            </td>
            <td width="29%">
              Out : <span>{{ net?.network_output }}</span>
            </td>
            <td width="14%">
              Real time: <span>{{ net?.network_output_speed_realtime }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lock: false,
      speed: {}
    }
  },
  computed: {
    data() {
      let data = this.config
      data.forEach((item, index) => {
        data[index].network_input_speed_realtime = this.getSpeed('network_input_speed', index, item?.network_input_speed)
        this.speed[index]['network_input_speed'] = item?.network_input_speed
        data[index].network_output_speed_realtime = this.getSpeed('network_output_speed', index, item?.network_output_speed)
        this.speed[index]['network_output_speed'] = item?.network_output_speed
      })
      return data
    }
  },
  methods: {
    getSpeed(key, index, value) {
      if (!this.speed?.[index]) this.speed[index] = {}
      if (!this.speed?.[index]?.[key]) this.speed[index][key] = value
      return this.fordight(value - this.speed[index][key], 3)
    },
    fordight(dight, how) {
      let last = 0 + 'B/s'
      if (dight < 0) {
        last = 0 + 'B/s'
      } else if (dight < 1024) {
        last = Math.round(dight * Math.pow(10, how)) / Math.pow(10, how) + 'B/s'
      } else if (dight < 1048576) {
        dight = dight / 1024
        last = Math.round(dight * Math.pow(10, how)) / Math.pow(10, how) + 'K/s'
      } else {
        dight = dight / 1048576
        last = Math.round(dight * Math.pow(10, how)) / Math.pow(10, how) + 'M/s'
      }
      return last
    }
  },
  props: {
    config: Object
  }
}
</script>
